import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextInput from 'components/form/TextInput';
import LogoVideoOption from '../LogoVideoOption';
import Button from 'components/Button';
import ColorPicker from 'components/form/ColorPicker';

const Design = ({ data, onInputChange, onStepChange }) => {
  const {
    collection_title,
    collection_description,
    logo_or_video_url,
    logo_or_video,
    primary_color,
    collection_text_color,
  } = data;
  const [t] = useTranslation('groups');

  const isValid = () => {
    let valid = true;
    if (logo_or_video) {
      valid = !!logo_or_video_url;
    }
    valid = valid && collection_title && collection_description;
    return valid;
  };

  return (
    <div>
      <Typography paragraph fontWeight={500}>
        Select Widget Styling
      </Typography>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography color="text.secondary">Primary Color</Typography>
        <ColorPicker
          value={primary_color}
          onChange={(val) =>
            onInputChange({
              target: { name: 'primary_color', value: val },
            })
          }
          size="small"
        />
      </Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Typography color="text.secondary">Text Color</Typography>
        <ColorPicker
          value={collection_text_color}
          onChange={(val) =>
            onInputChange({
              target: { name: 'collection_text_color', value: val },
            })
          }
          size="small"
        />
      </Stack>
      <Box mb={4}>
        <LogoVideoOption
          logo_or_video={logo_or_video}
          logo_or_video_url={logo_or_video_url}
          onInputChange={onInputChange}
        />
      </Box>
      <Typography fontWeight={500}>Edit Headline and Description</Typography>
      <TextInput
        fullWidth
        name="collection_title"
        value={collection_title}
        onChange={onInputChange}
        label="Headline"
      />
      <TextInput
        fullWidth
        name="collection_description"
        value={collection_description}
        onChange={onInputChange}
        label="Description"
      />
      <Box mt={3}>
        <Button fullWidth disabled={!isValid()} onClick={() => onStepChange(1)}>
          {t('common:next', 'Next')}
        </Button>
      </Box>
    </div>
  );
};

export default Design;
